import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox"];

  async toggle() {
    const token = document.querySelector('meta[name="csrf-token"]')?.content;

    try {
      const response = await fetch("/discover/toggle_recommendations", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRF-Token": token,
        },
      });

      if (response.ok) {
        const { show_recommendations } = await response.json();
        this.checkboxTarget.checked = show_recommendations;
      }
    } catch {
      // Revert checkbox on failure
      this.checkboxTarget.checked = !this.checkboxTarget.checked;
    }
  }
}
